import { createGlobalStyle } from "styled-components";

export const Styles = createGlobalStyle`

    @font-face {
        font-family: "EB Garamond";
        src: url("/fonts/EBGaramond.ttf") format("truetype");
        font-style: italic;
        font-weight: normal;
    }
    
     @font-face {
        font-family: "Inter", sans-serif;
        src: url("/fonts/inter.ttf") format("truetype");
            }




    body,
    html,
    a {
        font-family: "Inter", sans-serif;
    }


    body {
        background: rgba(244, 245, 243, 0.5);
        padding:0;
        border: 0;
        outline: 0;
        overflow-x: hidden;
        color: #393939;
    }

    a:hover {
        color: #39393940;
    }

    input,
    textarea {
        border-radius: 4px;
        border: 0;
        background: #ffffffff;
        color: #393939;
        transition: all 0.3s ease-in-out;  
        outline: none;
        width: 100%;  
        padding: 1rem 1.25rem;

        :focus-within {
            background: none;
            box-shadow: #393939 0px 0px 0px 1px;
        }
    }

            h1,
            h2,
            h3,
            h4,
            h5,
            h6 {
                    font-family: "EB Garamond", sans-serif;
                    font-style: italic;
                    color: #393939;
                    font-size: 56px;
                    line-height: 1.18;

                    @media only screen and (max-width: 890px) {
                        font-size: 47px;
                    }
      
                    @media only screen and (max-width: 414px) {
                        font-size: 32px;
                    }
            }

    p {
        color: #393939;
        font-size: 21px;        
        line-height: 1.41;
    }

    h1 {
        font-weight: 600;
    }

    a {
        text-decoration: none;
        outline: none;
        color: #393939;

        :hover {
            color: #393939;
        }
    }
    
    *:focus {
        outline: none;
    }

    .about-block-image svg {
        text-align: center;
    }

    .ant-drawer-body {
        display: flex;
        flex-direction: column;
        text-align: left;
        padding-top: 1.5rem;
    }

    .ant-drawer-content-wrapper {
        width: 300px !important;
    }
`;
